<style scoped>
      template { margin:auto;}
      h2, h4, p { text-align:center; }
	  th {background-color: #eeeeee; text-align:left;}
	  th.title { text-align:center; }
	  .container { width:50%; margin: auto; float:left; margin-bottom: 10px; }
	  table { width:100%; }
	  table tr td, table tr th { border: 1px solid; }
      .spacer {padding: 10px;}
      #customerLabel { margin-bottom: 20px; }
      .barcode-font {height: 90px}
      @media print {
          * {font-size:10px;}
          #customerLabel { margin-bottom: 35px; }
          .spacer {padding: 1px;}
          template { margin: 0px; padding: 0px;}
          #btnPrint { display:none; }
          h2, h4, p { font-size:12px; }
          @page { size: landscape; }
         .barcode-font {height: 60px}
      }
</style>
<template>
   <div class="container-fluid">
       <div> <input type="button" id="btnPrint" onclick="javascript: window.print()" value="Print" /> </div>
    <div class="container">
        <div>
            <h2>Order Summary</h2>
        </div>
        <div>
            <h4>Participant Copy</h4>
        </div>
        <div v-if="Order.jobType == 'FTC'">
            <p>If needed, keep this half for your records</p>
        </div>
        <div v-else>
            <p>If needed, keep this half for your records</p>
        </div>
        <div>
            <table>
                <tbody>
                    <tr>
                        <th colspan="2" class="title">Participant Information</th>
                        <th colspan="2" class="title">Order Identification</th>
                    </tr>
                    <tr>
                        <th>Name</th>
                        <td>{{Account.accountType == 1 ? Account.primaryContact.firstName + ' ' + Account.primaryContact.lastName + ' ' + Account.primaryContact.suffix : Account.primaryContact.legalName}} </td>
                        <!-- <td colspan="2" rowspan="2" class="barcode barcode-font" align="center">{{Order.orderNumber}}</td> -->
                        <td colspan="2" rowspan="2" align="center"><vue-barcode :value="Order.orderNumber" :options="{ displayValue: false }" class="barcode-font"></vue-barcode></td>
                    </tr>
                    <tr>
                        <th>Email</th>
                        <td>{{Account.emailAddress}}</td>
                    </tr>
                    <tr>
                        <th>Phone</th>
                        <td>{{Account.primaryContact.phoneNumber | phone_format}}</td>
                        <th>Patient</th>
                        <td>{{Order.patLastName}}, {{Order.patFirstName}}</td>
                    </tr>
                    <tr>
                        <th rowspan="3">Shipping Address</th>
                        <td rowspan="3">{{Order.shippingFullName}} <br/> {{Order.shippingAddressLineOne}} {{Order.shippingAddressLineTwo}} {{Order.shippingCity}} {{Order.shippingState}} {{Order.shippingPostcode}}</td>
                        <th>E-Order #:</th>
                        <td>{{Order.orderNumber}}</td>
                    </tr>
                    <tr>
                      <th>Order Ref/PO:</th>
                      <td>{{Order.referenceNoPo}}</td>
                    </tr>
                    <tr>
                        <th>Submitted:</th>
                        <td>{{FormatDateToLocal(Order.dateSubmitted)}}</td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="spacer"></div>
        <div>
            <table>
                <tbody>
                    <tr>
                        <th colspan="8" class="title">Prescription</th>
                    </tr>
                    <tr>
                        <th></th>
                        <th>Sphere</th>
                        <th>Cyl</th>
                        <th>Axis</th>
                        <th>Addition</th>
                        <th>Seg. Height</th>
                        <th>Dist PD</th>
                        <th>Near PD</th>
                    </tr>
                    <tr>
                        <th>Right eye</th>
                        <td>{{Order.reSph}}</td>
                        <td>{{Order.reCyl}}</td>
                        <td>{{Order.reAxis}}</td>
                        <td>{{Order.reAdd}}</td>
                        <td>{{Order.reSegHeight}}</td>
                        <td v-if="!Order.isOnly1DistancePD" class="order-confimation-description">{{Order.reDistPD}}</td>
                        <td v-else rowspan="2" class="order-confimation-description"><p style="margin-top:20px;">{{Order.distancePD}}</p></td>
                        <td v-if="!Order.isOnly1NearPD" class="order-confimation-description">{{Order.reNearPD}}</td>
                        <td v-else rowspan="2" class="order-confimation-description"><p style="margin-top:20px;">{{Order.nearPD}}</p></td>
                    </tr>
                    <tr>
                        <th>Left Eye</th>
                        <td>{{Order.leSph}}</td>
                        <td>{{Order.leCyl}}</td>
                        <td>{{Order.leAxis}}</td>
                        <td>{{Order.leAdd}}</td>
                        <td>{{Order.leSegHeight}}</td>
                        <td v-if="!Order.isOnly1DistancePD" class="order-confimation-description">{{Order.leDistPD}}</td>
                        <td v-if="!Order.isOnly1NearPD" class="order-confimation-description">{{Order.leNearPD}}</td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div v-if="Order.IncludeAdditionalRxFields">
            <table>
                <tbody>
                    <tr>
                    </tr>
                    <tr>
                        <th></th>
                        <th>Horizontal Prism</th>
                        <th>Base</th>
                        <th>Vertical Prism</th>
                        <th>Base</th>
                        <th>OC Height</th>
                    </tr>
                    <tr>
                        <th>Right eye</th>
                        <td>{{Order.reHorizontalPrismValue}}</td>
                        <td>{{Order.reHorizontalPrismDirection}}</td>
                        <td>{{Order.reVerticalPrismValue}}</td>
                        <td>{{Order.reVerticalPrismDirection}}</td>
                        <td>{{Order.reocHeight}}</td>
                    </tr>
                    <tr>
                        <th>Left Eye</th>
                        <td>{{Order.leHorizontalPrismValue}}</td>
                        <td>{{Order.leHorizontalPrismDirection}}</td>
                        <td>{{Order.leVerticalPrismValue}}</td>
                        <td>{{Order.leVerticalPrismDirection}}</td>
                        <td>{{Order.leocHeight}}</td>
                    </tr>                 
                </tbody>
            </table>
        </div>           
        <div class="spacer"></div>
        <div>
            <table>
                <tbody>
                    <tr>
                        <th colspan="2" class="title">Lens Information</th>
                        <th v-if="Order.jobType != 'UNC'" colspan="2" class="title">Frame Information</th>
                    </tr>
                    <tr>
                        <th>Order Type</th>
                        <td>{{Order.jobTypeDescription}}</td>
                        <th v-if="Order.jobType != 'UNC'">Manufacturer</th>
                        <td v-if="Order.jobType != 'UNC'">{{Order.frameManufacturer}}</td>
                    </tr>
                    <tr>
                        <th>Lens Type</th>
                        <td>{{Order.lensTypeDescription}}</td>
                        <th v-if="Order.jobType != 'UNC'">Brand</th>
                        <td v-if="Order.jobType != 'UNC'">{{Order.frameBrand}}</td>
                    </tr>
                    <tr>
                        <th>Design</th>
                        <td>{{Order.lensDesignDescription}}</td>
                        <th v-if="Order.jobType != 'UNC'">Name/Model</th>
                        <td v-if="Order.jobType != 'UNC'">{{Order.frameModel}}</td>
                    </tr>
                    <tr>
                        <th>Material</th>
                        <td>{{Order.lensMaterialDescription}}</td>
                        <th v-if="Order.jobType != 'UNC'">Frame Type</th>
                        <td v-if="Order.jobType != 'UNC'"><span v-if="Order.jobType != 'UNC'">{{Order.frameTypeDescription}}</span></td>
                    </tr>
                    <tr>
                        <th rowspan="4">Treatment(s)</th>
                        <td rowspan="4">
                            <ul v-for="lensItem in Order.lensTreatmentDescription">
                                <li>{{ lensItem }}</li>
                            </ul>
                        </td>
                    </tr>
                    <tr>
                        <th v-if="Order.jobType != 'UNC'">Color</th>
                        <td v-if="Order.jobType != 'UNC'">{{Order.frameColor}}</td>
                    </tr>
                    <tr>
                        <th v-if="Order.jobType != 'UNC'">Eye Size</th>
                        <td v-if="Order.jobType != 'UNC'">{{Order.frameEyeSize}}</td>
                    </tr>
                </tbody>
            </table>
            <div class="spacer"></div>
            <table>
                <tbody>
                    <tr>
                        <th class="title">Dispensing Notes (Not Sent to Lab)</th>
                    </tr>
                    <tr>
                        <td style="padding:15px;">{{Order.dispenserNotes}}</td>
                    </tr>
                </tbody>
            </table>
            <div class="spacer"></div>
            <table>
                <tbody>
                    <tr>
                        <th colspan="2" class="title">Lab Information</th>
                        <th colspan="2" class="title">Order Identification</th>
                    </tr>
                    <tr>
                        <th>Name</th>
                        <td>{{Order.orderLab.name}}</td>
                        <td colspan="2" rowspan="2" align="center"><vue-barcode :value="Order.orderNumber" :options="{ displayValue: false }" class="barcode-font"></vue-barcode></td>
                    </tr>
                    <tr>
                        <th>Phone #</th>
                        <td>{{"(866) 385-0447"}}</td>
                    </tr>
                    <tr>
                        <th rowspan="4">Shipping Address</th>
                        <td rowspan="4">{{Order.orderLab.shippingStreet}} {{Order.orderLab.shippingCity}} {{Order.orderLab.shippingStateCode}} {{Order.orderLab.shippingPostalCode}}</td>
                        <th>Patient</th>
                        <td>{{Order.patLastName}}, {{Order.patFirstName}}</td>
                    </tr>
                    <tr>
                        <th>E-Order #:</th>
                        <td>{{Order.orderNumber}}</td>
                    </tr>
                    <tr>
                        <th>Order Ref/PO:</th>
                        <td>{{Order.referenceNoPo}}</td>
                    </tr>
                    <tr>
                        <th>Submitted:</th>
                        <td>{{FormatDateToLocal(Order.dateSubmitted)}}</td>
                    </tr>
                </tbody>
            </table>
        </div>
        <!-- <input type="button" onclick="javascript: window.print()" value="Print" /> -->
    </div>
    <div v-if="Order.jobType == 'FTC'" class="container">
        <div>
            <h2>Order Summary - Lab Copy</h2>
        </div>
        <div>
            <p>Send this half with the frame to the lab within 1-2 business days.<br>
            <p v-if="Order.isRemakeRedo">
              Use the return shipping label that was included with the original order to send the order back to the lab. If you did not receive a return label, please contact support at <a href="support@onesight.org">support@onesight.org</a> or (866) 385-0447
            </p>
            <span style="color: red; font-weight: bold;">Frames shipped to the wrong lab will be drastically delayed or lost.</span></p>
        </div>
        <div>
            <table>
                <tbody>
                    <tr>
                        <th colspan="2" class="title">Participant Information</th>
                        <th colspan="2" class="title">Order Identification</th>
                    </tr>
                    <tr>
                        <th>Name</th>
                        <td>{{Account.accountType == 1 ? Account.primaryContact.firstName + ' ' + Account.primaryContact.lastName + ' ' + Account.primaryContact.suffix : Account.primaryContact.legalName}} </td>
                        <td colspan="2" rowspan="2" align="center"><vue-barcode :value="Order.orderNumber" :options="{ displayValue: false }" class="barcode-font"></vue-barcode></td>
                    </tr>
                    <tr>
                        <th>Email</th>
                        <td>{{Account.emailAddress}}</td>
                    </tr>
                    <tr>
                        <th>Phone</th>
                        <td>{{Account.primaryContact.phoneNumber | phone_format}}</td>
                        <th>Patient</th>
                        <td>{{Order.patLastName}}, {{Order.patFirstName}}</td>
                    </tr>
                    <tr>
                        <th rowspan="3">Shipping Address</th>
                        <td rowspan="3">{{Order.shippingFullName}} <br/> {{Order.shippingAddressLineOne}} {{Order.shippingAddressLineTwo}} {{Order.shippingCity}} {{Order.shippingState}} {{Order.shippingPostcode}}</td>
                        <th>E-Order #:</th>
                        <td>{{Order.orderNumber}}</td>
                    </tr>

                    <tr>
                      <th>Order Ref/PO:</th>
                      <td>{{Order.referenceNoPo}}</td>
                    </tr>
                    <tr>
                        <th>Submitted:</th>
                        <td>{{FormatDateToLocal(Order.dateSubmitted)}}</td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="spacer"></div>
        <div>
            <table>
                <tbody>
                    <tr>
                        <th colspan="8" class="title">Prescription</th>
                    </tr>
                    <tr>
                        <th></th>
                        <th>Sphere</th>
                        <th>Cyl</th>
                        <th>Axis</th>
                        <th>Addition</th>
                        <th>Seg. Height</th>
                        <th>Dist PD</th>
                        <th>Near PD</th>
                    </tr>
                    <tr>
                        <th>Right eye</th>
                        <td>{{Order.reSph}}</td>
                        <td>{{Order.reCyl}}</td>
                        <td>{{Order.reAxis}}</td>
                        <td>{{Order.reAdd}}</td>
                        <td>{{Order.reSegHeight}}</td>
                        <td v-if="!Order.isOnly1DistancePD" class="order-confimation-description">{{Order.reDistPD}}</td>
                        <td v-else rowspan="2" class="order-confimation-description"><p style="margin-top:20px;">{{Order.distancePD}}</p></td>
                        <td v-if="!Order.isOnly1NearPD" class="order-confimation-description">{{Order.reNearPD}}</td>
                        <td v-else rowspan="2" class="order-confimation-description"><p style="margin-top:20px;">{{Order.nearPD}}</p></td>
                    </tr>
                    <tr>
                        <th>Left Eye</th>
                        <td>{{Order.leSph}}</td>
                        <td>{{Order.leCyl}}</td>
                        <td>{{Order.leAxis}}</td>
                        <td>{{Order.leAdd}}</td>
                        <td>{{Order.leSegHeight}}</td>
                        <td v-if="!Order.isOnly1DistancePD" class="order-confimation-description">{{Order.leDistPD}}</td>
                        <td v-if="!Order.isOnly1NearPD" class="order-confimation-description">{{Order.leNearPD}}</td>
                    </tr>                  
                </tbody>
            </table>
        </div>
        <div>
            <table v-if="Order.AdditionalRXFields">
                <tbody>
                    <tr>
                        <th colspan="8" class="title">Additional RX Fields</th>
                    </tr>
                    <tr>
                        <th></th>
                        <th>Horizontal Prism</th>
                        <th>Base</th>
                        <th>Vertical Prism</th>
                        <th>Base</th>
                        <th>OC Height</th>
                    </tr>
                    <tr>
                        <th>Right eye</th>
                        <td>{{Order.reHorizontalPrismValue}}</td>
                        <td>{{Order.reHorizontalPrismDirection}}</td>
                        <td>{{Order.reVerticalPrismValue}}</td>
                        <td>{{Order.reVerticalPrismDirection}}</td>
                        <td>{{Order.reocHeight}}</td>
                    </tr>
                    <tr>
                        <th>Left Eye</th>
                        <td>{{Order.leHorizontalPrismValue}}</td>
                        <td>{{Order.leHorizontalPrismDirection}}</td>
                        <td>{{Order.leVerticalPrismValue}}</td>
                        <td>{{Order.leVerticalPrismDirection}}</td>
                        <td>{{Order.leocHeight}}</td>
                    </tr>                 
                </tbody>
            </table>
        </div>        
        <div class="spacer"></div>
        <div>
            <table>
                <tbody>
                    <tr>
                        <th colspan="2" class="title">Lens Information</th>
                        <th colspan="2" class="title">Frame Information</th>
                    </tr>
                    <tr>
                        <th>Order Type</th>
                        <td>{{Order.jobTypeDescription}}</td>
                        <th>Manufacturer</th>
                        <td>{{Order.frameManufacturer}}</td>
                    </tr>
                    <tr>
                        <th>Lens Type</th>
                        <td>{{Order.lensTypeDescription}}</td>
                        <th>Brand</th>
                        <td>{{Order.frameBrand}}</td>
                    </tr>
                    <tr>
                        <th>Design</th>
                        <td>{{Order.lensDesignDescription}}</td>
                        <th>Name/Model</th>
                        <td>{{Order.frameModel}}</td>
                    </tr>
                    <tr>
                        <th>Material</th>
                        <td>{{Order.lensMaterialDescription}}</td>
                        <th>Frame Type</th>
                        <td><span v-if="Order.jobType != 'UNC'">{{Order.frameTypeDescription}}</span></td>
                    </tr>
                    <tr>
                        <th rowspan="4">Treatment(s)</th>
                        <td rowspan="4">
                            <ul v-for="lensItem in Order.lensTreatmentDescription">
                                <li>{{ lensItem }}</li>
                            </ul>
                        </td>
                    </tr>
                    <tr>
                        <th>Color</th>
                        <td>{{Order.frameColor}}</td>
                    </tr>
                    <tr>
                        <th>Eye Size</th>
                        <td>{{Order.frameEyeSize}}</td>
                    </tr>
                </tbody>
            </table>
            <div class="spacer"></div>
            <table>
                <tbody>
                    <tr>
                        <td style="background-color:#eeeeee">Please do not add any additional order instructions or requests to this sheet. For special order requests, place the order again and check "The lens options above do not meet the medical needs of this patient".</td>
                    </tr>
                </tbody>
            </table>
            <div class="spacer"></div>
            <table style="border:5px dashed red;">
                <tbody>
                    <tr>
                        <th colspan="2" class="title">Lab Information</th>
                        <th colspan="2" class="title">Order Identification</th>
                    </tr>
                    <tr>
                        <th>Name</th>
                        <td>{{Order.orderLab.name}}</td>
                        <td colspan="2" rowspan="2" align="center"><vue-barcode :value="Order.orderNumber" :options="{ displayValue: false }" class="barcode-font"></vue-barcode></td>
                    </tr>
                    <tr>
                        <th>Phone #</th>
                        <td>{{"(866) 385-0447"}}</td>
                    </tr>
                    <tr>
                        <th rowspan="4">Shipping Address</th>
                        <td rowspan="4">{{Order.orderLab.shippingStreet}} {{Order.orderLab.shippingCity}} {{Order.orderLab.shippingStateCode}} {{Order.orderLab.shippingPostalCode}}</td>
                        <th>Patient</th>
                        <td>{{Order.patLastName}}, {{Order.patFirstName}}</td>
                    </tr>
                    <tr>
                        <th>E-Order #:</th>
                        <td>{{Order.orderNumber}}</td>
                    </tr>

                    <tr>
                      <th>Order Ref/PO:</th>
                      <td>{{Order.referenceNoPo}}</td>
                    </tr>
                    <tr>
                        <th>Submitted:</th>
                        <td>{{FormatDateToLocal(Order.dateSubmitted)}}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</div>
</template>

<script>
    function InitialData(orderId)
    {
        return {
            Order: {},
            Account: {}
        }
    }
    import HeaderComponent from "@/components/shared/HeaderComponent";
    import FooterComponent from "@/components/shared/FooterComponent";
    import VueBarcode from '@xkeshi/vue-barcode';
    export default {
        components: {HeaderComponent, FooterComponent, VueBarcode},
        data(){
            return InitialData();
        },
        mounted:function(){
            this.GetOrderById(this.$route.query.orderId) //method1 will execute at pageload
        },
        methods: {
            GetOrderById(orderId){
                var _this = this;

                axios.get('/Order/GetOrderAccount/' +  orderId, {headers: {'Authorization': "Bearer " + localStorage.getItem("token")}}).then(function (response) {
                    _this.Order = response.data.raw.order;
                    _this.Account = response.data.raw.account;
                })
                .catch(function (error) {
                    console.log(error);
                });
            }
        }
    }
</script>



// WEBPACK FOOTER //
// OrderSummary.vue?5a7107b0